// КАТАЛОГ СТАТЕЙ
'use strict';

function Articles() {

    // Реализация пагинации
    let paginationItem = document.querySelectorAll('.js-pagination__item'),
    paginationPrev = document.querySelector('.js-pagination__prev'),
    paginationNext = document.querySelector('.js-pagination__next');
    let arrPaginationItem = Array.from(paginationItem); // массив из коллекции

    for (let i = 0; i < paginationItem.length; i++) {
        arrPaginationItem[i].addEventListener('click', function(event) {
        event.preventDefault();
        // console.log(arrPaginationItem.indexOf(this)); // индекс нажатого элемента массива
        paginationPrev.style.display = 'none'; // по умолчанию стрелка назад скрыта

        for (let j = 0; j < paginationItem.length; j++) {
            paginationItem[j].classList.remove('pagination__item--active');
            if (arrPaginationItem.indexOf(this) != 0) { // если нажат не первый элемент
                paginationPrev.style.display = 'block';
            } 
        }
        // если не кнопки вперед/назад
        if (this.classList.contains('js-pagination__prev') || this.classList.contains('js-pagination__next')) {
            this.classList.remove('pagination__item--active');
        } else {
            this.classList.add('pagination__item--active');
        }

        });
    }


    // Переход на страницу конкретной статьи через главную страницу или страницу Статей
    let articles = document.querySelectorAll('.js-choice-flex__item');

    for (let i = 0; i < articles.length; i++) {
        articles[i].addEventListener('click', function () {
            // console.log('Вы перешли на страницу со статьями');           
        });
    }


};


export {
    Articles
};